import { FC } from "react";
import { BasePageContainer, Heading4 } from "../TrueUI";
import FormBoxWrapper from "./FormBoxWrapper";
import style from "./formBoxMain.module.css";

const FormBoxMain: FC<any> = () => {
  return (
    <div className={style.formbox_page_container}>
      <BasePageContainer
        id="formbox-main"
        title={
          <div className={style.main_title_container}>
            <Heading4 className={style.main_title}>Formbox</Heading4>
          </div>
        }
        titlePosition="center"
        maxWidth="lg"
        disableBodyPaper={true}
        data={true}
      >
        <FormBoxWrapper />
      </BasePageContainer>
    </div>
  );
};

export default FormBoxMain;
